// ========== 世界数据 ==========
import { S } from '../state.js';
export const REGIONS = [
  { id:'forest', name:'格兰之森', lvReq:1,  icon:'🌲', firstScene:'elven_start', flag:'beat_forest',
    desc:'幽暗的古老森林，哥布林与亡灵出没', beatenScenes:['gf_7_done'] },
  { id:'hetonmar', name:'赫顿玛尔', lvReq:10, icon:'🏰', firstScene:'heton_town', flag:'beat_hetonmar',
    desc:'繁华的冒险者都市，地下城遍布', beatenScenes:['ht_magic_done'] },
  { id:'dark_city', name:'暗黑城', lvReq:15, icon:'🕯️', firstScene:'dc_entrance', flag:'beat_dark_city',
    desc:'地下的暗精灵王国，诺伊佩拉瘟疫正在蔓延——与格兰之森相同的紫色碎片', beatenScenes:['dc_citadel_done'] },
  { id:'sky_city', name:'天空之城', lvReq:18, icon:'☁️', firstScene:'sky_city_gate', flag:'beat_sky',
    desc:'漂浮云端的远古遗迹，龙王盘踞', beatenScenes:['sky_dragon_done'] },
  { id:'behemoth', name:'天帷巨兽', lvReq:25, icon:'🐋', firstScene:'behemoth_arrival', flag:'beat_behemoth',
    desc:'漂浮于天空的巨兽背脊——使徒罗特斯在此进行精神控制', beatenScenes:['behemoth_final_done'] },
  { id:'scasa', name:'斯顿雪域', lvReq:30, icon:'🏔️', firstScene:'scasa_camp', flag:'beat_scasa',
    desc:'班图族的故乡，冰龙斯卡萨在此沉睡了千年——如今它醒了', beatenScenes:['scasa_final_done'] },
  { id:'pandemonium', name:'魔界入口', lvReq:35, icon:'🌑', firstScene:'pande_gate', flag:'beat_pande',
    desc:'通往魔界的裂隙——赫尔德正在彼端注视着你', beatenScenes:['pande_final_done'] },
];

export const DUNGEONS = {
  forest: [
    { id:'gf_dark_forest', name:'幽暗密林', lvReq:1,
      desc:'格兰之森的第一道关卡，哥布林出没的阴暗林地。',
      scenes:['gf_1','battle_goblin2','battle_goblin_chief','gf_1_boss_done','gf_2','gf_2_skip','battle_zombie1','gf_2_done'] },
    { id:'gf_thunder', name:'雷鸣废墟', lvReq:5, unlockAfter:'gf_dark_forest',
      desc:'被雷光笼罩的古代精灵圣地，落雷凯诺在此盘踞。',
      scenes:['gf_3','battle_thunder_minion','battle_thunder_boss','gf_3_done','gf_3_chest'] },
    { id:'gf_poison', name:'猛毒沼泽', lvReq:8, unlockAfter:'gf_thunder',
      desc:'紫雾弥漫的毒沼，变异史莱姆的巢穴。',
      scenes:['gf_4','battle_poison','gf_4_done'] },
    { id:'gf_flame', name:'烈焰格拉卡', lvReq:10, unlockAfter:'gf_poison',
      desc:'火海中的牛头怪领地，烈焰彼诺修镇守的赤红之地。',
      scenes:['gf_5','battle_tau_beast','battle_tau_chief','gf_5_done','gf_6','battle_flame_goblin','battle_flame_boss','gf_6_done'] },
    { id:'gf_dark_thunder', name:'暗黑雷鸣废墟', lvReq:12, unlockAfter:'gf_flame',
      desc:'格兰之森的最终试炼，盗尸者骨狱息沉眠之处。',
      scenes:['gf_7','battle_bone_dragon','gf_7_done'] },
  ],
  hetonmar: [
    { id:'ht_dungeon', name:'罗兰河地下城', lvReq:10,
      desc:'赫顿玛尔郊外古老的地下城，被诅咒的骑士徘徊其中。',
      scenes:['ht_dungeon_1','battle_cursed_knight','ht_dungeon_boss','battle_golem_guard','ht_dungeon_done'] },
    { id:'ht_gbl_shrine', name:'GBL神殿废墟', lvReq:12, unlockAfter:'ht_dungeon',
      desc:'被遗忘的GBL教神殿遗址，狂热教徒在冰龙气息中陷入疯狂。',
      scenes:['ht_gbl_1','battle_gbl_zealot','battle_gbl_bishop','ht_gbl_done'] },
    { id:'ht_magic', name:'魔法公会研究院', lvReq:14, unlockAfter:'ht_gbl_shrine',
      desc:'被冰封女巫占据的魔法研究设施，暗影魔法失控蔓延。',
      scenes:['ht_magic_1','battle_shadow_mage','battle_ice_witch','ht_magic_done'] },
    { id:'ht_ice_lair', name:'冰龙的气息·冰窟', lvReq:16, unlockAfter:'ht_magic',
      desc:'冰龙斯卡萨的力量在这里留下了永恒不化的冰川。',
      scenes:['ht_ice_1','battle_dark_sorcerer','battle_ice_witch_boss','ht_ice_done'] },
  ],
  sky_city: [
    { id:'sky_gate', name:'天空之城·入口', lvReq:18,
      desc:'浮游云端的古代遗迹入口，石像鬼扑翼守护。',
      scenes:['sky_city_gate','battle_cloud_gargoyle','sky_1_done'] },
    { id:'sky_dragon_tower', name:'龙人之塔', lvReq:18, unlockAfter:'sky_gate',
      desc:'天空之城中段的龙族兵营，巴卡尔麾下最精锐的龙人士兵在此守卫千年。',
      scenes:['dragon_tower_0','battle_dragon_soldier','dragon_tower_1','battle_dragon_centurion','dragon_tower_done'] },
    { id:'sky_temple', name:'天空之城·神殿', lvReq:20, unlockAfter:'sky_dragon_tower',
      desc:'上古神殿的核心区域，堕落天使长在此守门。',
      scenes:['sky_altar','sky_altar_offer','sky_2','battle_storm_hawk','battle_angel_fallen','sky_2_done'] },
    { id:'sky_dark_corridor', name:'黑暗玄廊', lvReq:21, unlockAfter:'sky_temple',
      desc:'神殿深处的封印回廊，赫尔德的爪牙在此布下杀阵。',
      scenes:['dark_corridor_0','battle_dark_knight_sky','dark_corridor_1','battle_corridor_mage','dark_corridor_done'] },
    { id:'sky_dragon_lair', name:'天空龙王巢穴', lvReq:22, unlockAfter:'sky_dark_corridor',
      desc:'天空之城的至高点，传说之龙盘踞于云端。',
      scenes:['battle_sky_dragon','sky_dragon_done','final_boss_intro','battle_arad_demon','final_victory'] },
  ],
  behemoth: [
    { id:'behemoth_shrine', name:'GBL神殿入口', lvReq:25,
      desc:'天帷巨兽背上的GBL教神殿。狂热的教徒在使徒的低语中失去了自我。',
      scenes:['behemoth_shrine_1','battle_gbl_highpriest','behemoth_shrine_done'] },
    { id:'behemoth_tentacle', name:'罗特斯的触手之海', lvReq:26, unlockAfter:'behemoth_shrine',
      desc:'巨兽背脊的内陆海域。罗特斯巨大的触手从深水中伸出，控制着周围的一切生命。',
      scenes:['behemoth_tentacle_1','battle_tentacle_swarm','battle_tentacle_giant','behemoth_tentacle_done'] },
    { id:'behemoth_temple', name:'罗特斯神殿', lvReq:28, unlockAfter:'behemoth_tentacle',
      desc:'GBL教的大神殿——如今已是罗特斯的巢穴。空气浓稠得像在水中呼吸。',
      scenes:['behemoth_temple_1','battle_mindslave_1','battle_mindslave_2','battle_lotos','behemoth_final_done'] },
  ],
  scasa: [
    { id:'scasa_pass', name:'冰霜峡谷', lvReq:30,
      desc:'通往斯顿雪域的必经之路。极寒风暴中隐藏着被冰龙召唤的冰雪怪物。',
      scenes:['scasa_pass_1','battle_frost_giant','scasa_pass_done'] },
    { id:'scasa_cave', name:'冰龙巢穴·外庭', lvReq:31, unlockAfter:'scasa_pass',
      desc:'冰龙巢穴的外围区域。墙壁上覆盖着千年的冰层，冰层中封存着古老的班图族文物。',
      scenes:['scasa_cave_1','battle_ice_wyrm','battle_ice_golem','scasa_cave_done'] },
    { id:'scasa_lair', name:'冰龙巢穴·核心', lvReq:33, unlockAfter:'scasa_cave',
      desc:'斯卡萨沉睡的中心。冰龙的呼吸让空间扭曲，温度低到盔甲都会碎裂。',
      scenes:['scasa_lair_1','battle_scasa_whelps','battle_scasa','scasa_final_done'] },
  ],
  pandemonium: [
    { id:'pande_abyss', name:'深渊裂隙', lvReq:35,
      desc:'魔界入口——空间在这里被打碎。赫尔德的力量已经渗透到了阿拉德的边缘。',
      scenes:['pande_abyss_1','battle_void_beast','pande_abyss_done'] },
    { id:'pande_citadel', name:'赫尔德的行宫', lvReq:37, unlockAfter:'pande_abyss',
      desc:'第二使徒在魔界的住所。无尽的图书馆中收藏着泰拉的记忆——和她所有的计划。',
      scenes:['pande_citadel_1','battle_shadow_apostle','battle_hera','pande_final_done'] },
  ],
  dark_city: [
    { id:'dc_outpost', name:'暗精灵前哨', lvReq:15,
      desc:'暗黑城的入口哨站，守卫在此拦截所有闯入者。',
      scenes:['dc_1','battle_dark_elf_soldier','battle_shadow_beast','dc_outpost_done'] },
    { id:'dc_cavern', name:'亡魂洞穴', lvReq:17, unlockAfter:'dc_outpost',
      desc:'千年亡魂徘徊的地下洞穴，幽灵骑士在此巡逻。',
      scenes:['dc_cavern_1','battle_dark_priest','battle_ghost_knight','dc_cavern_done'] },
    { id:'dc_citadel', name:'暗黑要塞', lvReq:20, unlockAfter:'dc_cavern',
      desc:'暗黑城的核心堡垒，暗影领主在此等待挑战者。',
      scenes:['dc_citadel_1','battle_spider_queen','dc_citadel_boss','battle_shadow_lord','dc_citadel_done'] },
  ],
};

export const DUNGEON_CHAINS = {
  forest: ['gf_dark_forest','gf_thunder','gf_poison','gf_flame','gf_dark_thunder'],
  hetonmar: ['ht_dungeon','ht_gbl_shrine','ht_magic','ht_ice_lair'],
  dark_city: ['dc_outpost','dc_cavern','dc_citadel'],
  sky_city: ['sky_gate','sky_dragon_tower','sky_temple','sky_dark_corridor','sky_dragon_lair'],
  behemoth: ['behemoth_shrine','behemoth_tentacle','behemoth_temple'],
  scasa: ['scasa_pass','scasa_cave','scasa_lair'],
  pandemonium: ['pande_abyss','pande_citadel']
};

export const NPCS = {
  sera: {
    id:'sera', name:'赛丽亚', title:'药剂商人', emoji:'💊',
    desc:'欢迎光临！需要些什么吗？旅途辛苦了~',
    image:'assets/npc/npc_sera.png',
    location:['lobby'],
    dialogues:{
      default:['今天的天气真好呢~冒险家，有什么需要帮忙的吗？',
               '最近格兰之森的魔物越来越多了……希望你能平安回来。',
               '要小心那些哥布林，它们虽然小，但成群结队的时候很可怕！',
               '你知道吗？这座大厅曾经是精灵们聚会的地方呢。',
               '旅途辛苦了，坐下来喝杯热茶吧~',
               '有时候我会想……我是谁？我从哪里来？这些问题总是困扰着我。'],
      beat_forest:['格兰之森的危机解除了？太好了！不愧是冒险家！',
                   '我在你身上看到了希望……阿拉德大陆需要你这样的人。',
                   '那片紫色碎片……我碰它的时候，脑子里闪过了奇怪的画面。大火、精灵、还有……一双紫色的眼睛。',
                   '你知道吗？我最近开始做梦了。梦里有个女人的声音在呼唤我……但我不认识她。',
                   '如果……如果我真的不是普通人，你会害怕吗？'],
      beat_hetonmar:['赫顿玛尔的冒险也结束了吗？你的名声已经传遍整个大陆了！',
                     '能够打破冰龙的诅咒……你已经不是普通的冒险家了。',
                     'GSD说的事情让人害怕。如果我是使徒……那意味着什么？',
                     '赫尔德在利用所有人。包括你，包括我。但我们不是棋子——对吗？',
                     '天空之城有巴卡尔的遗产。也许那里有关于我过去的答案。'],
      beat_sky:['天空之城……巴卡尔的遗产……你真的做到了。',
               '有时候我在想，你究竟是谁的转世呢？算了，这不重要。',
               '我是第十三使徒。我是卡洛索的碎片。但首先——我是赛丽亚，你的朋友。',
               '赫尔德想利用我们完成她的预言。但我们不会让她得逞的。',
               '谢谢你选择保护我。从现在起，我不再是一个人了。'],
      rep_hero:['你总是选择善良和信任。这让我相信——即使是使徒，也可以选择成为什么样的人。'],
      rep_shadow:['你的路和我不同。但我知道你在用自己的方式反抗赫尔德。这就够了。'],
    },
  },
  jarmerchant: {
    id:'jarmerchant', name:'土罐', title:'罐子商人', emoji:'🏺',
    desc:'来来来！以钱赚钱啦！绝对不亏！',
    image:'assets/npc/npc_jarmerchant.png',
    location:['forest'],
    dialogues:{
      default:['来来来！以钱赚钱啦！今天运气特别好！',
               '我的罐子里可都是好东西，信不信由你！',
               '嘘——别告诉别人，这批货可是从帝国宝库里来的。',
               '赌一把？万一中了呢？人生就是一场豪赌！',
               '我这生意做了一百年了，从来没亏过——也没赚过。'],
      beat_forest:['哟！森林变得安静了！那些紫色雾气散掉之后，我的生意好多了！',
                  '要不要买个罐子庆祝一下？给你打折——嗯，原价打九九折！',
                  '精灵们不在了，但他们的宝贝还留在森林里。我捡到不少好东西呢~'],
      beat_hetonmar:['赫顿玛尔！大城市就是不一样，这里的冒险家出手可大方了！',
                    '班图族的难民说冰龙醒了？嘿，那正是发财的好时机——我是说，帮他们重建家园！'],
      beat_sky:['天空之城你都能上去？那地方我可不敢去！太高的地方我腿软。',
               '不过你既然上去了，有没有捡到什么龙族的宝贝？我高价收购！嗯……出价一金币。'],
    },
  },
  blacksmith: {
    id:'blacksmith', name:'林纳斯', title:'铁匠', emoji:'🔨',
    desc:'装备交给我，保证让它更强！',
    image:'assets/npc/npc_blacksmith.png',
    location:['forest'],
    dialogues:{
      default:['哟，冒险家！装备需要强化一下吗？我的铁锤可不是吃素的！',
               '这把剑不错……但还可以更强。交给我吧！',
               '当年我可是帝国第一铁匠铺的首席弟子。后来……算了，不提了。',
               '你知道吗？打铁就像人生——千锤百炼才能成器。',
               '你的装备上沾了不少魔物的血。擦一擦吧，对武器好。'],
      beat_forest:['格兰之森安静下来了。铁锤敲在钢上的声音终于不再被怪物的嚎叫打断。',
                  '那些紫色碎片不是普通矿石。我锻了一下——铁锤差点被腐蚀穿！精灵们用生命才把它封住。你小心。',
                  '冰龙醒了之后，北方矿石涨了三倍！这年头开铁匠铺也不容易啊……'],
      beat_hetonmar:['班图族的人说他们的武器在冰龙面前就跟纸片一样。我在想办法——用天空之城的寒铁也许能锻造出对抗冰龙的兵器。',
                    '你见过GSD了？那个瞎子老头的剑，是我年轻时打的最好的一把。可惜那年之后他就瞎了……'],
      beat_sky:['天空之城的龙晶碎片……给我看看。天啊，这是巴卡尔的龙鳞粉末！有了这个，我能打出超越传说的兵器！',
               '你知道吗，当年巴卡尔被推翻时，很多龙族武器失传了。现在你带回了它们的材料——也许失传的技艺可以重现。'],
    },
  },
  kiri: {
    id:'kiri', name:'凯丽', title:'强化师', emoji:'⚡',
    desc:'路过的那个小伙儿，挺帅的嘛！要试试强化吗？失败了可别怪我哟~',
    image:'assets/npc/npc_kiri.png',
    location:['hetonmar'],
    dialogues:{
      default:['哟~帅哥！今天要不要来强化一下？我可是专业的！',
               '强化嘛~成功了你开心，失败了你可别哭鼻子哟~',
               '你知道为什么我的强化成功率比别人高吗？因为——我在说大话！',
               '这把武器不错，但如果加点我的魔法强化……嘿嘿~',
               '天界科技+魔法强化，我可是独此一家，别无分店！',
               '砰！哈哈~只是开个玩笑。你真的要强吗？'],
      beat_forest:['森林的事听说了。紫色碎片？那玩意儿可别带到我的店里来——上次一块矿石差点把整条街炸了！',
                  '不过话说回来，这种危险的东西如果用在强化上……可能会擦出不一样的火花？'],
      beat_hetonmar:['GSD那个怪老头也来了？他可从来不强化的——说剑要靠"心"。哈！心能比我的强化机更厉害吗？',
                    '班图族难民说冰龙把他们的铁匠铺全毁了。切，他们要是早来找我，武器早就+10了！'],
      beat_sky:['天空之城！天界来的！那上面肯定有天界的科技。你能不能帮我带点天界零件回来？我拿免费强化三次跟你换！',
               '巴卡尔的龙晶？天啊，那东西的魔力值足以驱动一整座城市！如果用来强化武器……嘿嘿嘿……'],
    },
  },
  grandis: {
    id:'grandis', name:'歌兰蒂斯', title:'首饰商人', emoji:'💍',
    desc:'这些首饰蕴含着神圣的力量……只有被选中的人才能驾驭。',
    image:'assets/npc/npc_grandis.png',
    location:['hetonmar'],
    dialogues:{
      default:['欢迎光临。看看这些首饰吧，每一件都有它的故事。',
               '这枚戒指曾经属于一位伟大的圣骑士……戴上它，你能感受到他的意志吗？',
               '首饰不只是装饰品。在关键时刻，它们能救你一命。',
               '我走遍了整个阿拉德大陆，只为收集这些蕴含着神圣力量的宝物。',
               '美丽的首饰配勇敢的冒险家——这是世上最好的搭配。',
               '邪恶如同灯光下的阴影，即使看不见也会存在。但光明永远更强。'],
      beat_forest:['格兰之森的瘟疫碎片……我哥哥尼尔巴斯在调查类似的东西时失踪了。那是十年前的事了。',
                  '他是一名圣职者。如果他还活着，一定在某个地方继续对抗黑暗。',
                  '如果有一天你遇到了一个高大的圣职者，请告诉他——妹妹一直在等他回家。'],
      beat_hetonmar:['赫顿玛尔的冰龙事件让我想起了哥哥最后的行动——他也是在调查某种来自魔界的异常力量。',
                    'GSD和艾丽丝说的"使徒"……我哥哥的调查笔记里出现过这个词。也许他真的找到了什么重要的东西。'],
      beat_sky:['巴卡尔的遗产中说到了天界。我哥哥最后出现的地方就在天界附近。如果他还在那里……',
               '谢谢你为阿拉德做的一切。如果你去天界，请一定要帮我找到他的消息。这枚戒指——算是预付的报酬。'],
    },
  },
  norton: {
    id:'norton', name:'诺顿', title:'炼金术师', emoji:'⚗️',
    desc:'药剂是一门精密的科学，不是随便搅一搅就行的。',
    image:'assets/npc/npc_norton.png',
    location:['hetonmar'],
    dialogues:{
      default:['啊，是冒险家啊。要买药剂吗？我的药剂可是经过精确配比的。',
               '你知道吗？一瓶合格的HP药剂需要经过37道工序。37道！',
               '巴卡尔的龙息粉末……再加一点月光花的花蕊……嗯，这个配方绝对能行！',
               '炼金术是一门被低估的艺术。很多人以为搅一搅就行，真是荒谬！',
               '如果你在冒险中发现了稀有材料，记得带回来给我研究。',
               '科学的力量太伟大了！魔法？哼，那只是我们还没搞懂的物理而已。'],
      beat_forest:['你从森林带回来的紫色碎片——我分析了整整三天。这是人为合成的瘟疫物质，自然界中绝对不存在。',
                  '瘟疫的源头在魔界。具体来说，是一个叫狄瑞吉的使徒。有人把它的碎片转移到了格兰之森。',
                  '请再多收集一些样本。我需要更多的数据来确定转移的手法。'],
      beat_hetonmar:['暗黑城和格兰之森的样本对比完成了。同一种瘟疫，不同的投放点——这是系统性的散布，有人在刻意制造阿拉德的内乱。',
                    '而且手法非常精妙：每处的瘟疫浓度都经过严格控制，恰好足以引起混乱但不至于完全毁灭生态。这不是普通人的手笔。'],
      beat_sky:['巴卡尔的龙晶数据让我确定了最后一块拼图。瘟疫的转移手法和巴卡尔当年被转移到阿拉德的手法完全一致。是同一个人——赫尔德。',
               '我调制了一瓶抗体。它不能杀死使徒，但能保护你免受狄瑞吉瘟疫的侵蚀。如果你去魔界——带上它。'],
    },
  },
  // === GSD ===
  gsd: {
    id:'gsd', name:'G·S·D', title:'鬼剑士导师', emoji:'🗡️',
    desc:'用心感受剑的气息……而不是用眼睛。',
    image:'assets/npc/gsd_portrait_v2.png',
    location:['hetonmar'],
    dialogues:{
      default:['你来了。虽然我看不见，但能感受到你身上的剑意。',
               '剑不是用眼睛看的，是用心去感受的。闭上眼睛试试。',
               '我虽然瞎了，但看到的比很多人都多。鬼神的领域……你想了解吗？',
               '每一个剑士都要找到属于自己的"理"。你的理是什么？',
               '我年轻时曾经去过虚祖——那里的剑术，和阿拉德完全不同。'],
      beat_forest:['你在格兰之森的表现我都知道了。你的剑在成长。',
                   '继续走下去吧，总有一天你会超越我。',
                   '使徒，来自魔界的十三位强大存在。狄瑞吉只是其中一个的碎片。',
                   '有人在把它们转移到阿拉德。幕后主使是第二使徒——赫尔德。',
                   '你的剑沾染了使徒的血。但记住：你不是屠夫，你在保护这片土地。'],
      beat_hetonmar:['冰龙的苏醒绝非巧合。斯卡萨在恐惧——恐惧某种比它更强大的力量。',
                    '巴卡尔的遗产在天空之城。他在死前留下了真相。找到它，你就会明白一切。',
                    '剑不会迟疑。你的心在动摇？这是好事——犹豫意味着你在思考，而不是盲从。',
                    '每个使徒都是被转移过来的。希洛克、罗特斯、巴卡尔……它们本不该出现在阿拉德。'],
      beat_sky:['巴卡尔的遗产……你比我想象的走得更远。',
               '也许，你真的能终结赫尔德的阴谋。',
               '你选择了保护赛丽亚。不是赫尔德的刀，而是阿拉德的盾。老头子我的剑还没钝。',
               '接下来是罗特斯和斯卡萨。战争远未结束。但至少现在——你知道该为谁而战。'],
      rep_hero:['你的仁慈不是软弱。在赫尔德的棋局中，仁慈是最锋利的武器。'],
      rep_shadow:['你多疑、冷酷——但有时这正是对抗阴谋所需要的。不要丢失自己。'],
    },
  },
  // === 天空之城 NPC ===
  bakal_echo: {
    id:'bakal_echo', name:'巴卡尔的残响', title:'龙王的记忆', emoji:'🐉',
    desc:'五百年来，我一直在这龙晶中等待……等待那个不被赫尔德操纵的人。',
    image:'assets/npc/npc_bakal_echo.png',
    location:['sky_city'],
    dialogues:{
      default:['你终于来了……比她预言的更早。','龙晶里封存着五百年的真相。你想知道吗？','我不是来战斗的。我只是巴卡尔留下的一道记忆。',
               '五百年的等待。终于有人来了——不是赫尔德派来的刀，而是真正的倾听者。'],
      beat_forest:['你在格兰之森见过紫色的雾气了？那是狄瑞吉的碎片。','赫尔德的手法——把使徒转移到阿拉德，让你们替她消灭。',
                   '每一个死去的使徒都是赫尔德的棋子。我也是。但至少我死前留下了真相。'],
      beat_hetonmar:['冰龙斯卡萨……它也是赫尔德的棋子。所有使徒都是。','你打败了冰灵？很好。但真正的敌人从未出现在战场上。',
                     '赫尔德不敢亲自来阿拉德。她只会躲在魔界，通过预言和转移来操控一切。'],
      beat_sky:['你已经知道了真相。赛丽亚——她是第十三使徒。','保护她。赫尔德最想得到的就是卡洛索的碎片。',
               '你是预言中唯一的变数。赫尔德没有预料到你会自主思考——这正是我们的优势。'],
      rep_hero:['你选择保护而非杀戮……这才是真正的勇气。','巴卡尔大人会为你骄傲的。'],
    }
  },
  sosia: {
    id:'sosia', name:'索西雅', title:'天空酒馆老板娘', emoji:'🍷',
    desc:'在这云端开酒馆可不是什么浪漫的事……但总得有人给冒险家们一个歇脚的地方。',
    image:'assets/npc/npc_sosia.png',
    location:['sky_city'],
    dialogues:{
      default:['欢迎来到天空酒馆~想喝点什么？','在这云海上开酒馆，客人比地上的少，但每个都很有趣。'],
      beat_forest:['格兰之森……那里曾经是精灵最美的家园。我就是从那里逃出来的。','你打败了骨狱息？谢谢你。虽然那片森林已经回不去了……'],
      beat_sky:['巴卡尔的真相……我不知道是该高兴还是难过。','但现在至少我们知道敌人是谁了。来，这杯算我请的。'],
    }
  },
  dragon_scholar: {
    id:'dragon_scholar', name:'龙人学者', title:'远古记录官', emoji:'📜',
    desc:'我在这里抄录了五百年的龙族历史……但最重要的那一页，巴卡尔大人亲手撕掉了。',
    image:'assets/npc/npc_dragon_scholar.png',
    location:['sky_city'],
    dialogues:{
      default:['你想看龙族的历史？那可要花不少时间……','五百年了。我是这里最后一个还活着的龙人。'],
      beat_forest:['你在找关于使徒的记录？我这里有一些……但有些页面被封印了。','只有击败了天空龙王的冒险家才能查看那些封印的记录。'],
      beat_sky:['封印解除了。你想看什么？巴卡尔大人的遗言？还是……赫尔德的计划？','这些知识很危险。但你已经赢得了知晓它们的权利。'],
    }
  },
};

export const ZONES = {
  elven: {
    name:'艾尔文防线', lv:1, scenes:[
      { id:'elven_start', title:'艾尔文防线·格兰之森前哨',
        text:`阿拉德历 985 年。
        
十年前那场大火几乎烧尽格兰之森，精灵一族随之消失。
没有人知道原因。只知道从那以后，森林就变了——哥布林
变得狂暴，死者从泥土中爬出，连空气都带着腐败的甜味。

你站在艾尔文防线的木栅栏外。疲惫的卫兵交头接耳：
「又有一队人进去了，三天了还没出来……」

银发少女靠在枯树旁。她叫赛丽亚——没人知道她从哪里来，
只知道她在火灾后出现在森林边缘，失去了所有记忆。

她抬起眼眸看向你：
「你……也是来调查森林异变的冒险家吗？」`,
        choices:[
          { text:'「告诉我你知道的一切。」', next:'elven_say_yes' },
          { text:'「我习惯独自行动。」', next:'elven_say_no' },
          { text:'沉默点头，径直走进森林', next:'elven_enter' },
        ]
      },
      { id:'elven_say_yes', title:'火中的记忆',
        text:`「十年前……格兰之森起了一场大火。」赛丽亚握紧双手，
声音轻得几乎听不见。「我就是在那天醒来的，什么都记不得了。」
        
她顿了顿：「但最近我开始做梦。梦见一个被黑雾笼罩的身影，
站在火焰中……笑着。那不是普通的火。」

她从怀中取出一个布袋：「森林里的哥布林异常躁动，
连死去的精灵都开始复苏。请一定小心。」
        
✦ 获得：10 金币、初级HP药剂 ×2`,
        choices:[
          { text:'收下补给，踏入幽暗密林', next:'gf_1', gold:10, item:'hp_potion_s', item2:'hp_potion_s' },
        ]
      },
      { id:'elven_say_no', title:'戒备',
        text:`赛丽亚眼中闪过一丝失望，但很快恢复平静。
「至少记住——有些怪物不是自然产生的。它们像被什么东西污染了。」
她指向森林深处：「你自己去看吧。」`,
        choices:[
          { text:'进入幽暗密林', next:'gf_1' },
        ]
      },
      { id:'elven_enter', title:'沉默的决意',
        text:`你沉默地越过赛丽亚。身后传来她轻轻的声音：
「我在梦里见过你……请你一定平安回来。」
        
森林入口果然如她所言——几只哥布林正围着篝火嘶叫。
但它们的眼睛不对劲：瞳孔泛着暗紫色的微光，像被什么感染了。`,
        choices:[
          { text:'拔剑！迎战被感染的哥布林', next:'gf_1' },
        ]
      },
    ]
  },
  grand_flores: {
    name:'格兰之森', lv:1, scenes:[
      { id:'gf_1', title:'幽暗密林',
        text:`密林深处暗得反常。正午时分却像黄昏。
树皮上爬满了深紫色的菌斑——那不是自然界该有的颜色。
        
哥布林叽叽喳喳的叫声中掺杂着痛苦的呜咽。
前方的树影剧烈摇晃，一个巨大的轮廓正在逼近。
        
幽暗密林。十年前火灾最先吞噬的地方。`,
        choices:[
          { text:'迎战树影中的巨大身影', next:'battle_goblin_chief', fatigue:6 },
          { text:'搜索林间空地（紫雾弥散处有动静）', next:'battle_goblin2', fatigue:10 },
          { text:'返回大厅', action:'home' },
        ]
      },
      { id:'gf_1_boss_done', title:'幽暗密林·净化',
        text:`哥布林头目轰然倒地，眼中的紫光终于熄灭了。
        
你注意到它倒下后，周围的紫色菌斑似乎淡了几分。
仿佛它本身就是这片腐败的源头之一。
        
远处隐约传来低沉的……呼吸声？很深，很远，像从地下传来。`,
        choices:[
          { text:'跟随呼吸声深入密林', next:'gf_2' },
          { text:'返回大厅', action:'home' },
        ]
      },
      { id:'gf_2', title:'亡者复苏之地',
        text:`深入密林，空气中的甜腻味越来越浓。
那是腐败的气息——不止是植物，还有……尸体。
        
地面松软得反常。几双惨白的手从泥土中伸出，无力地抓挠。
        
那些手的主人穿着古老的精灵服饰——他们是十年前
葬身火海的精灵。本该安息的他们，被某种力量唤醒了。`,
        choices:[
          { text:'踏过这片死亡之地（脚下触到了冰冷的手指）', next:'battle_zombie1', fatigue:8 },
          { text:'绕过这片亵渎的墓地', next:'gf_2_skip', fatigue:4 },
          { text:'返回大厅', action:'home' },
        ]
      },
      { id:'gf_2_skip', title:'绕路前行',
        text:`你绕开那片复苏的墓地，穿过荆棘丛。
精灵的亡者没有追来——也许他们并非有意识地攻击，
只是在某种力量牵引下盲目地徘徊。
        
前方隐约传来雷声。那不是自然的雷——太规律了，
像某种残存的防御魔法仍在运转。`,
        choices:[
          { text:'朝着雷声前进——那是精灵的遗迹', next:'gf_3' },
          { text:'折返清理那些被亵渎的亡者', next:'battle_zombie1', fatigue:4 },
        ]
      },
      { id:'gf_2_done', title:'亡者安息',
        text:`最后一个精灵亡者化为尘埃。风中似乎传来一声
轻得几乎听不见的叹息——是解脱，还是感谢？
        
雷声仍在继续，不远了。那里应该是精灵族的古圣地。
也许那里有关于这场异变的答案。`,
        choices:[
          { text:'前往雷鸣废墟——精灵圣地', next:'gf_3' },
          { text:'返回大厅', action:'home' },
        ]
      },
      { id:'gf_3', title:'雷鸣废墟·精灵圣地',
        text:`雷光劈开乌云，照亮了废墟残垣。
古老的精灵符文残留在断壁上，微弱地闪烁。
        
这里曾经是精灵族的圣地。十年前大火中，
精灵们正是在此处集合，用生命加固了大魔法阵——
保护了整个阿拉德大陆，却牺牲了自己。
        
废墟中心的雷光异常聚集。有什么在那里——守护着，或是被困着。`,
        choices:[
          { text:'探查废墟边缘（雷光中有人形轮廓移动）', next:'battle_thunder_minion', fatigue:6 },
          { text:'走向雷光聚集的中心', next:'battle_thunder_boss', fatigue:8 },
          { text:'返回大厅', action:'home' },
        ]
      },
      { id:'gf_3_done', title:'圣地·净化',
        text:`落雷凯诺的狂怒终于平息。那个被扭曲的精灵守护者
在最后一道雷光中化为光点，散入风中。
        
你单膝跪地，发现废墟祭坛上有一行精灵语的刻痕——
虽然残缺，但仍可辨认：「我们封印了它……的一部分。」
        
"它"是谁？
        
祭坛底部有一个古朴的宝箱，尘封已久。`,
        choices:[
          { text:'打开精灵族遗留的宝箱', next:'gf_3_chest' },
        ]
      },
      { id:'gf_3_chest', title:'精灵的遗赠·抉择',
        text:`宝箱中躺着一枚泛着微光的护符——
精灵族锻造的最后一批圣物。
        
护符上刻着：「愿雷光守护这片土地，直到黑暗退散。」
        
但你低头看到宝箱旁边，有一小堆焚烧过的遗骨。
那是精灵的遗骸——十年前在火中牺牲的守护者。
护符是他们最后的遗物。拿走它，你获得力量。
留下它，你尊重亡者的安息。`,
        choices:[
          { text:'将护符放回宝箱，合上盖子。「安息吧。」——仁者之路 +1', next:'gf_4_or_5', gold:100, onEnter:function(){addRep('hero',1);setRepFlag('respected_elves');} },
          { text:'取下护符——你需要它的力量。暗影之路 +1', next:'gf_4_or_5', gold:100, onEnter:function(){addRep('shadow',1);} },
        ]
      },
      { id:'gf_4_or_5', title:'岔路口',
        text:`不远处传来沉重的脚步声——牛头人的营寨就在前方。
但从这里的岔路向另一侧看去，紫黑色的毒雾
正从地面裂缝中汩汩涌出……`,
        choices:[
          { text:'前往格拉卡——牛头人营寨', next:'gf_5', gold:100 },
          { text:'探索猛毒雷鸣废墟（那里可能有关于"它"的线索）', next:'gf_4', gold:100 },
        ]
      },
      { id:'gf_4', title:'猛毒雷鸣废墟·瘟疫之源',
        text:`紫黑色的毒雾从地面每一道裂缝中涌出。
这不是自然界的毒沼——毒雾中夹杂着肉眼可见的
暗紫色微粒，落在皮肤上立即引发灼痛。
        
空气中弥漫着和森林入口一样的甜腻腐败味——
只是这里浓郁百倍。
        
远处传来黏腻的蠕动声。雾中有什么东西在生长。`,
        choices:[
          { text:'屏住呼吸闯入毒雾（雾里有东西在动）', next:'battle_poison', fatigue:10, needLv:5 },
          { text:'太危险了——先去格拉卡', next:'gf_5' },
        ]
      },
      { id:'gf_4_done', title:'瘟疫之源·暂封',
        text:`你在毒雾中杀出一条路，怪物化为脓水。
但你注意到一件怪事：每一个死去的怪物体内
都飘出同样的紫色微粒，缓缓向森林更深处飘去……
        
仿佛它们只是某个更大存在的碎片。
        
✦ 获得：320 金币、中级HP药剂 ×2、解毒药 ×1`,
        choices:[
          { text:'跟着紫色微粒的方向去格拉卡', next:'gf_5', gold:320, item:'hp_potion_m', item2:'hp_potion_m', extraItem:'antidote' },
          { text:'中毒太深，先回城治疗', next:'lobby', gold:320, item:'hp_potion_m', item2:'hp_potion_m', extraItem:'antidote' },
        ]
      },
      { id:'gf_5', title:'格拉卡·牛头人营寨',
        text:`牛头人——格兰之森最强大的原住民。
十年前的大火吞噬了他们的家园，他们被迫迁徙到森林边缘。
        
但这些牛头人不太对劲。它们的眼睛闪烁着暗紫色的光，
动作比正常情况更加狂暴，似乎被某种力量驱使着愤怒。
        
营寨中心的巨大帐篷里传出沉重的呼吸——
牛头王正在那里。空气中有烧灼的焦味，来自营地后方的
冲天火光……`,
        choices:[
          { text:'正面踏入营寨（沉重的脚步声逼近）', next:'battle_tau_beast', fatigue:8 },
          { text:'潜入王帐挑战牛头王', next:'battle_tau_chief', fatigue:6 },
          { text:'绕过营寨，前往火光冲天的方向', next:'gf_6', fatigue:4 },
        ]
      },
      { id:'gf_5_done', title:'格拉卡·解放',
        text:`牛头王轰然倒下。紫光从它眼中消散——那一瞬间，
它的表情不再是狂暴，而是……解脱。
        
营寨中幸存的牛头兵四散奔逃，眼中的紫色也淡了。
你从王座后的箱子里找到大量金币。一旁还掉落着
一片烧焦的羊皮纸，上面潦草地写着：
        
「那东西在暗黑雷鸣废墟的最深处……
　十年前火中坠落的碎片……」`,
        choices:[
          { text:'前往烈焰格拉卡（羊皮纸所指的方向）', next:'gf_6', gold:200 },
          { text:'返回大厅', action:'home', gold:200 },
        ]
      },
      { id:'gf_6', title:'烈焰格拉卡·燃尽的记忆',
        text:`十年前大火的余烬，至今仍在燃烧。
地面龟裂，熔岩渗出，空气被热浪扭曲。
        
这片区域是当年火灾的中心。精灵族正是在这里
做出了最后的牺牲。如今火焰仍在燃烧——
就好像那场火的源头从未熄灭过。
        
火海中，巨大的火焰轮廓缓缓转向你。
那不是普通的火焰精灵——它的体内，你能看到
暗紫色的微粒在跳动。`,
        choices:[
          { text:'在火海边缘清理火焰魔物', next:'battle_flame_goblin', fatigue:8 },
          { text:'直冲火焰核心挑战彼诺修', next:'battle_flame_boss', fatigue:6 },
          { text:'返回大厅', action:'home' },
        ]
      },
      { id:'gf_6_done', title:'烈焰·平息',
        text:`烈焰彼诺修发出最后的悲鸣，庞大的火焰身躯爆散。
        
火焰熄灭的瞬间，你看到了一个短暂的幻象——
十年前的那个夜晚：精灵们站在火焰中，手挽着手，
将自己的生命力注入地面，加固大魔法阵。
        
然后，一颗暗紫色的"星辰"从天空坠落——
带着不祥的笑声，砸入了森林的最深处。
        
你从灰烬中捡起一把仍在散发余温的武器。
前方——暗黑雷鸣废墟。羊皮纸上说的"那东西"，就在那里。`,
        choices:[
          { text:'前往暗黑雷鸣废墟——直面森林异变的源头', next:'gf_7' },
          { text:'返回大厅', action:'home' },
        ]
      },
      { id:'gf_7', title:'暗黑雷鸣废墟·深渊入口',
        text:`格兰之森的至暗之地。连空气都凝固了。
        
这里没有任何活物。连被感染的哥布林都不敢靠近。
只有低沉而有节奏的……呼吸。来自地下。
        
地面裂开一道巨大的缝隙，暗紫色的雾气从中涌出。
这就是羊皮纸所指的地方——十年前"坠落的碎片"。
        
裂缝边缘刻着精灵语。你勉强辨认：
「吾等以生命为代价封印此地……
　封印日渐衰弱……它仍在生长……」
        
裂缝深处，一双紫色的眼睛缓缓睁开。`,
        choices:[
          { text:'跃入裂缝——终结这一切', next:'battle_bone_dragon', fatigue:12, needLv:4 },
          { text:'先回去准备，这不是一般的怪物', action:'home' },
        ]
      },
      { id:'gf_7_done', title:'格兰之森·紫雾消散',
        text:`盗尸者骨狱息——被狄瑞吉碎片扭曲的远古亡者，
在凄厉的嘶吼中化为漫天骨粉。紫黑色的雾气从它体内
喷涌而出，然后……
        
消散了。十年了，森林第一次真正安静下来。
阳光穿透密林，洒在你脚下的碎石上。
        
你弯腰捡起一块暗紫色的结晶碎片。它仍在微微搏动——
像一个活着的东西。赛丽亚说过她的梦里，有黑雾中的身影。
精灵的遗言提到"它仍在生长"。
        
这不是一块简单的碎片。它是一个更大存在的一部分——
一个被刻意"转移"到格兰之森的瘟疫之源。
        
远处传来马蹄声。一个穿着吟游诗人装束的女子停在森林边缘，
远远望向你。她的眼睛是深紫色的，和那些碎片一模一样。
        
然后她微笑了一下，消失在树影中。
        
🏆 格兰之森 完全通关！
✦ 获得：500 金币、中级HP药剂 ×3
        
【新的疑问】是谁纵了格兰之火？谁把瘟疫碎片降落在此处？
那个紫瞳的吟游诗人……是敌是友？`,
        onEnter: function() {
          S.flags.beat_forest = true;
          if(!S.flags._forest_epilogue_shown) {
            S.flags._forest_epilogue_shown = true;
            setTimeout(() => renderChapterEpilogue('forest', () => {
              renderLobby(); renderTopbar(); renderStatusbar();
            }), 300);
          }
        },
        choices:[
          { text:'带着满腹疑问返回赛丽亚身边', next:'lobby', gold:500, item:'hp_potion_m', item2:'hp_potion_m', extraItem:'hp_potion_m' },
        ]
      },
    ]
  },
  hetonmar: {
    name:'赫顿玛尔', lv:10, scenes:[
      { id:'heton_town', title:'赫顿玛尔·冒险者之都',
        text:`赫顿玛尔——阿拉德大陆最繁华的都市。
魔法公会的尖塔直插云霄，铁匠铺的炉火日夜不息。

但今天的气氛有些不对。广场上挤满了穿着皮毛衣衫的
北方人——班图族的难民。他们用粗犷的口音诉说着：
「雪山在震动……冰龙斯卡萨醒了！」

你注意到人群中有一个瞎子老人——紧闭双眼，
却似乎"看见"了你。他的左臂缠绕铁链，衣袍下
泛着暗红色的光。

「你身上……有紫色碎片的气息。」他缓缓开口。
「我叫GSD。跟我来，有些事情你该知道了。」

▶ GSD的邀约 · 需要Lv.10
▶ 东：罗兰河地下城（Lv.12+）
▶ 西：魔法师公会（Lv.14+）
▶ 北：天空之城入口（Lv.18+）
▶ 地下：暗黑城入口（Lv.15+）`,
        choices:[
          { text:'跟随GSD——他认识那些紫色碎片', next:'heton_gsd', needLv:10, fatigue:2, onEnter:function(){addRep('hero',1);setRepFlag('trusted_gsd');} },
          { text:'无视他，去铁匠铺', next:'heton_shop' },
          { text:'探索罗兰河地下城', next:'ht_dungeon_1', needLv:12, fatigue:6 },
          { text:'前往魔法师公会区域', next:'ht_magic_1', needLv:14, fatigue:8 },
          { text:'🕯️ 潜入暗黑城', next:'dc_entrance', needLv:15, fatigue:6 },
          { text:'返回大厅', action:'home' },
        ]
      },
      { id:'heton_gsd', title:'G.S.D·暗黑城的剑圣',
        text:`老人在街角停下。「我瞎了，但我看到的比谁都多。」

「你在森林里碰到的东西——那是"使徒"狄瑞吉的碎片。
使徒，是魔界最强大的存在。一共有十三位。而你碰到的，
只是其中一员的残渣。」

他的表情变得严肃。「使徒本不该出现在阿拉德。
但最近几十年，它们一个接一个地被"转移"到这里——
希洛克在悲鸣洞穴，罗特斯在天帷巨兽，现在狄瑞吉
的碎片在格兰之森。」

「有人在把它们送过来，让冒险家替她杀掉。」
「第二使徒——赫尔德。所有事件的幕后主使。」

「冰龙斯卡萨的苏醒绝非巧合。去罗兰河地下城和
魔法公会调查。我会在这里等你的消息。」

【暗线解锁】揭秘"使徒"与"转移"——赫尔德的棋局`,
        choices:[
          { text:'「我去调查冰龙的线索。」', next:'ht_dungeon_1', needLv:12, fatigue:6 },
          { text:'「让我先准备一下装备。」', next:'heton_town' },
        ]
      },
      { id:'heton_shop', title:'铁匠铺',
        text:`铁匠大叔正在锻造一把冰蓝色的巨剑。
那是为北方远征军准备的武器。

「哟！你也听说了？斯卡萨醒了，整个雪域都在震动。
班图族说冰龙这次不太对——它的力量里掺杂着
某种外来的东西。跟你从森林里带出来的那种
紫色玩意儿有关吗？」

「来来来，这批武器用北方寒铁打的——对付冰系怪物有奇效！」`,
        choices:[
          { text:'初级HP药剂（5金）', next:'buy_hp_s', needGold:5 },
          { text:'中级HP药剂（15金）', next:'buy_hp_m', needGold:15 },
          { text:'高级HP药剂（40金）', next:'buy_hp_l', needGold:40 },
          { text:'技能药剂（8金）', next:'buy_mp', needGold:8 },
          { text:'返回赫顿玛尔', next:'heton_town' },
        ]
      },
      { id:'buy_hp_s', title:'购买初级HP药剂',
        text:`「拿好！」\n✦ 获得：初级HP药剂 ×1`,
        choices:[
          { text:'再买一瓶', next:'buy_hp_s', gold:-5, needGold:5, item:'hp_potion_s' },
          { text:'返回铁匠铺', next:'heton_shop', gold:-5, item:'hp_potion_s' },
        ]
      },
      { id:'buy_hp_m', title:'购买中级HP药剂',
        text:`「这个效果更好，用了猛毒废墟的毒囊！」\n✦ 获得：中级HP药剂 ×1`,
        choices:[
          { text:'再买一瓶', next:'buy_hp_m', gold:-15, needGold:15, item:'hp_potion_m' },
          { text:'返回铁匠铺', next:'heton_shop', gold:-15, item:'hp_potion_m' },
        ]
      },
      { id:'buy_hp_l', title:'购买高级HP药剂',
        text:`「这是我的镇店之宝，天空之城水晶精华酿成！」\n✦ 获得：高级HP药剂 ×1`,
        choices:[
          { text:'再买一瓶', next:'buy_hp_l', gold:-40, needGold:40, item:'hp_potion_l' },
          { text:'返回铁匠铺', next:'heton_shop', gold:-40, item:'hp_potion_l' },
        ]
      },
      { id:'buy_mp', title:'购买技能药剂',
        text:`「这是魔法公会订制的，恢复技能值！」\n✦ 获得：技能药剂 ×1`,
        choices:[
          { text:'再买一瓶', next:'buy_mp', gold:-8, needGold:8, item:'mp_potion_s' },
          { text:'返回铁匠铺', next:'heton_shop', gold:-8, item:'mp_potion_s' },
        ]
      },
      { id:'ht_dungeon_1', title:'罗兰河地下城·冰封走廊',
        text:`赫顿玛尔城郊的古老地下城。
往年深秋都只是阴凉潮湿的通道，如今墙面结满冰霜——
冰龙的苏醒已影响到数百里外的这里。

走廊深处，被诅咒的骑士在冰封中徘徊。
它盔甲缝隙并非渗出普通的寒气——
那寒气中夹杂着一丝暗紫色的冷雾。`,
        choices:[
          { text:'迎战被冰霜附身的诅咒骑士', next:'battle_cursed_knight', fatigue:10 },
          { text:'入更深处——冰冻的源头在召唤', next:'ht_dungeon_boss', fatigue:6 },
          { text:'返回赫顿玛尔', next:'heton_town' },
        ]
      },
      { id:'ht_dungeon_boss', title:'远古守护者·苏醒',
        text:`地下城最深处。巨大的石像守卫着
通往北方雪域的古代通道。
        
几百年来它一直沉睡——直到冰龙苏醒唤醒了它。
石像的眼中亮起冰蓝色的光，脚下石板迅速结冰，
整个大厅被一股远古的冰封之力笼罩。`,
        choices:[
          { text:'石像动了——它要封死整个通道', next:'battle_golem_guard', fatigue:12, needLv:15 },
          { text:'先回去清理外围', next:'ht_dungeon_1' },
        ]
      },
      { id:'ht_dungeon_done', title:'地下城·冰封解除',
        text:`地界守卫者轰然崩塌，冰霜化为蒸汽。
古老的封印暂时解除。

石像的基座上刻着一行字：
「冰龙之息可封万物……除非找到巴卡尔的遗产。」

巴卡尔？传说中天界的暴龙王。
他在五百年前被推翻——但他的遗产还留存于阿拉德。
        
在哪里？石像的雕刻指向了——天空之城。
        
✦ 获得：350 金币`,
        choices:[
          { text:'前往GBL神殿废墟——冰龙的低语从后面传来', next:'ht_gbl_1', gold:350 },
          { text:'返回大厅', action:'home', gold:350 },
        ]
      },
      { id:'ht_gbl_1', title:'GBL神殿废墟·狂热之所',
        text:`穿过一片枯萎的树林，一座被遗弃的
GBL教神殿出现在你眼前。墙壁上爬满了
冰蓝色的苔藓——不应该出现在这个季节的东西。

神殿内部，身穿白袍的GBL信徒围成一圈，
低吟着同样的经文：「贝希摩斯沉眠，斯卡萨苏醒……
使徒归来之日，冰霜将洗净一切……」

他们的眼睛完全是白色的——瞳孔已经冻碎了。
冰龙的气息不仅唤醒了怪物，
还在改写活人的信仰。`,
        choices:[
          { text:'打断仪式——他们已不是活人', next:'battle_gbl_zealot', fatigue:10 },
          { text:'潜入神殿深处寻找主教', next:'battle_gbl_bishop', fatigue:8 },
          { text:'返回赫顿玛尔', next:'heton_town' },
        ]
      },
      { id:'ht_gbl_done', title:'GBL神殿·净化',
        text:`GBL主教倒下的瞬间，神殿中的寒冰终于
开始融化。墙上冰蓝色的苔藓迅速枯萎。

主教临死前用最后一息写道：
「吾等侍奉的真神并非贝希摩斯……
而是来自北方的冰之王。祂承诺予吾等永生，
代价是将这座神殿献给冰狱。」

他用血画了一个箭头：指向魔法公会。

你突然明白了——冰龙的力量不是从北面蔓延的。
是有人把它的力量召唤到了赫顿玛尔。

✦ 获得：300 金币`,
        choices:[
          { text:'前往魔法公会——他们在召唤冰龙的力量', next:'ht_magic_1', gold:300 },
          { text:'返回大厅', action:'home', gold:300 },
        ]
      },
      { id:'ht_magic_1', title:'魔法公会研究院·暴风雪',
        text:`魔法公会内部正被暴风雪肆虐——
这绝非自然现象。墙壁爬上诡异冰晶，
公会成员惊慌奔逃。

「冰龙的力量渗透到了这里！」一名法师喊道。
「研究院深层封印着古代冰灵——斯卡萨苏醒
冲破了封印！它在恐惧什么，所以把冰灵驱逐了出来——」

走廊深处传来冰冷的笑声。不是人类的声音——
是冰本身在模仿人类说话。`,
        choices:[
          { text:'清出一条通路——暗影在墙上扭曲成形', next:'battle_shadow_mage', fatigue:10 },
          { text:'冲向笑声源头——冰灵的核心', next:'battle_ice_witch', fatigue:8 },
          { text:'返回赫顿玛尔', next:'heton_town' },
        ]
      },
      { id:'ht_magic_done', title:'魔法公会·第二条线索',
        text:`冰封女巫——古代冰灵的最后一个碎片——在火焰中消散。
研究所的风暴平息了。

公会长踉跄走来，递给你一份烧焦的卷轴：
「冰灵消散前留下了这个……它不是古代的守护灵，
而是被冰龙从北方驱逐过来的！斯卡萨在恐惧什么——」

卷轴画着潦草的地图：箭头从雪山→赫顿玛尔→天空之城。
旁边写着：「冰龙的力量来自更高处——巴卡尔的遗产在召唤它。」

GSD说的"转移"……巴卡尔的"遗产"……
所有线索都指向天空之城。

街角，紫瞳的吟游诗人朝你走来。
这一次她没有消失。

艾丽丝微笑：「赫顿玛尔的麻烦暂时解决了。
但冰龙还在苏醒。天空之城——巴卡尔在那里
留下了关于赫尔德谋的全部真相。」
她顿了顿。「当你知道了真相……你得自己做选择。
顺从预言，还是……反抗？」

✦ 获得：500 金币`,
        onEnter: function() {
          S.flags.beat_hetonmar = true;
          if(!S.flags._heton_epilogue_shown) {
            S.flags._heton_epilogue_shown = true;
            setTimeout(() => renderChapterEpilogue('hetonmar', () => {
              renderLobby(); renderTopbar(); renderStatusbar();
            }), 300);
          }
        },
        choices:[
          { text:'追问艾丽丝——「你到底是谁？」', next:'heton_iris', needLv:10 },
          { text:'追踪冰龙气息的源头——冰窟', next:'ht_ice_1', needLv:16 },
          { text:'返回大厅', next:'lobby', gold:500 },
          { text:'返回赫顿玛尔', next:'heton_town', gold:500 },
        ]
      },
      { id:'heton_iris', title:'艾丽丝·吟游诗人',
        text:`「我是谁？」艾丽丝拨了一下琵琶。
音符在空中凝固了一秒。

「一个吟游诗人。一个预言者。」
她停顿了一秒，紫瞳闪过一丝你读不懂的情绪。
「……一枚棋子。和你一样。」

「赫尔德把使徒转移到阿拉德，让你们去消灭它们。
这是她的"预言"——使徒全部死去，泰拉才能重生。
你们只是她手中的刀。」

「而我……」她苦笑，「曾经也是她的刀。」

「天空之城。巴卡尔在被推翻前留下了真相。
找到他的遗产——你就会明白一切。」

她转身，披风轻扬：「记住，当你了解了真相之后，
你必须自己做出选择。」
        
✦ 额外获得：300 金币`,
        choices:[
          { text:'返回大厅——需要消化这一切', next:'lobby', gold:300 },
          { text:'去天空之城——巴卡尔的遗产在等着', next:'sky_city_gate', gold:300, needLv:18 },
        ]
      },
      // ==== 冰龙的气息 · 冰窟（赫顿玛尔终章）====
      { id:'ht_ice_1', title:'冰龙的气息·永恒冰川',
        text:`赫顿玛尔郊外的一处古老洞穴。普通冒险者
从不靠近这里——他们说听到龙息的声音。

洞穴内壁完全被万年不化的冰川覆盖。
这不是自然现象。冰龙斯卡萨的力量留下了
这片永恒的冻土，几百年不曾融化。

冰川的深处，一个被冰封的身影若隐若现——
一位古代暗术士，在冰龙苏醒的那一刻
吸收了大量冰龙之力后，陷入了永恒的冰封。
而他体内那颗冰心，仍在跳动。`,
        choices:[
          { text:'打破冰墙——暗术士的双眼突然睁开', next:'battle_dark_sorcerer', fatigue:12 },
          { text:'寻找冰心的裂隙', next:'battle_ice_witch_boss', fatigue:10, needLv:18 },
          { text:'返回赫顿玛尔', next:'heton_town' },
        ]
      },
      { id:'ht_ice_done', title:'冰龙的气息·源头断绝',
        text:`冰心碎裂。暗术士的身体化为冰晶崩解。

最后一缕冰龙的气息从洞穴中逸散——
向北方的雪域飘去。它在回到主人那里。

你在冰窟的深处发现了一块古老的龙鳞，
鳞片上刻着：「暴龙王巴卡尔的遗产，在天界之门。
冰龙守门，等待使徒尽灭之日。」

和之前的所有线索都对上了——
冰龙是巴卡尔的守门兽。巴卡尔的遗产在天空之城。
赫尔德想让你们一个个消灭使徒，
但巴卡尔——他留下了一条反抗的路。

✦ 获得：400 金币`,
        choices:[
          { text:'返回赫顿玛尔——将龙鳞带给艾丽丝', next:'heton_town', gold:400 },
          { text:'返回大厅', next:'lobby', gold:400 },
        ]
      },
    ]
  },
  sky_city: {
    name:'天空之城', lv:18, scenes:[
      { id:'sky_city_gate', title:'天空之城·云海之门',
        text:`赫顿玛尔北郊，巨大的魔法传送门悬浮在空中。
门后是阿拉德最古老的遗迹——天空之城。

GSD的声音在你脑海中回响：
「巴卡尔的遗产在那里。他留下了所有真相。」

传送门附近，一只石像鬼从云端俯冲而下——
它的眼中闪烁着古老的守护魔咒。
巴卡尔死后仍有人在守护他的秘密。`,
        choices:[
          { text:'迎战守护石像鬼——闯入天空之城', next:'battle_cloud_gargoyle', fatigue:10, needLv:18 },
          { text:'先回去准备好装备', next:'lobby' },
        ]
      },
      { id:'sky_1_done', title:'天空之城·云海平台',
        text:`石像鬼化为碎石坠落。云海在你脚下展开——
断裂的廊柱漂浮在白云之间，远古建筑残垣伸向天际。

远处，雷云在聚集。风暴中有一个巨大的身影在盘旋——
那是一只风暴猎鹰，它的存在远早于人类的记忆。

更远方，一座神殿的尖顶刺破云层。
那里就是巴卡尔最后的遗产所在。`,
        choices:[
          { text:'穿越云海平台——前方是龙族军营', next:'dragon_tower_0', fatigue:10 },
          { text:'先探索平台边缘的远古祭坛', next:'sky_altar' },
        ]
      },
      // === 龙人之塔 ===
      { id:'dragon_tower_0', title:'龙人之塔·兵营入口',
        text:`云海之中，一座由龙晶和黑曜石打造的巨塔拔地而起——
龙人之塔，巴卡尔为他的龙人士兵修建的军营。

塔身上刻满龙语铭文：
「龙族永不臣服。龙族永不休战。」

入口的铁门半开着，里面传来整齐的步伐声——
龙人士兵正在进行换岗巡逻。

空气中弥漫着龙炎残留的焦灼气味。这场守卫战
已经持续了五百年，从未停歇。`,
        choices:[
          { text:'潜入龙人之塔——突破第一道防线', next:'battle_dragon_soldier', fatigue:10, needLv:18 },
          { text:'先退回云海平台观察情况', next:'sky_1_done' },
        ]
      },
      { id:'dragon_tower_1', title:'龙人之塔·战痕大厅',
        text:`龙人士兵在你面前倒下——它的鳞甲散落一地。
但塔中的战斗远未结束。

你穿过兵营，走廊两旁是一排排石化的龙蛋。
巴卡尔曾试图在这里培育新的龙族军队，
但大多数龙蛋已经石化——失去了龙王的龙息，
它们永远不会孵化。

在走廊尽头的大厅中，你发现了一本龙语日记。
勉强能辨认出几行字：

「巴卡尔大人今日又批阅了一百二十份军报。
　他说赫尔德不会放过阿拉德。
　他说自己的时间……不多了。」`,
        choices:[
          { text:'继续攀登——塔顶有更强的守卫', next:'battle_dragon_centurion', fatigue:12, needLv:18 },
          { text:'搜寻兵营中的遗物', next:'dragon_tower_treasure', gold:200 },
        ]
      },
      { id:'dragon_tower_treasure', title:'龙族的遗赠',
        text:`你在兵营的角落发现了一个龙皮包裹的宝箱。
显然是一名龙人士兵在远征前留下的私人物品。

箱中有一袋金币和几件龙族护符——
虽然魔力已经微弱到近乎消失，
但仍能感受到其中残留的龙息之力。`,
        choices:[
          { text:'收下遗物，继续向上', next:'battle_dragon_centurion', fatigue:10 },
        ]
      },
      { id:'dragon_tower_done', title:'龙人之塔·征服',
        text:`龙人百夫长的巨剑砸在地板上，塔顶的石板四分五裂。

五百年。这么多龙族士兵在这里等待了五百年，
等待一个永远不会回来的君主。

百夫长倒下前说了一句话：
「巴卡尔大人……他早就知道自己会死。
　他留下我们，不是让我们守城，
　——是让我们等他预言中的那个人。」

龙人之塔终于沉寂。前方，云梯直通神殿——
光之城主赛格哈特还在那里守着最后的门。`,
        choices:[
          { text:'踏上云梯——目标：天空之城神殿', next:'sky_2', healing:20 },
          { text:'先回云海平台休整', next:'sky_1_done', healing:20 },
        ]
      },
      { id:'sky_altar', title:'巴卡尔的试炼',
        text:`祭坛并非精灵族所建——上面的铭文是龙语。
        
你勉强辨认出几行：
「欲承吾之遗产者，须献上战士之血——
　弱者不配知晓真相。」
        
祭坛中央，一个石质圣杯静候着献祭。
圣杯边缘沾染着暗红色的龙血——五百年仍未干涸。`,
        choices:[
          { text:'向圣杯献上中级HP药剂——接受试炼', next:'sky_altar_offer', needItem:'hp_potion_m' },
          { text:'滴入自己的鲜血——以HP为代价接受试炼', next:'sky_altar_offer', subHp:80 },
          { text:'不理会龙王的考验，继续前进', next:'sky_2' },
        ]
      },
      { id:'sky_altar_offer', title:'龙王的认可',
        text:(() => {
          const usedPotion = S.inventory.findIndex(inv => inv && inv.id === 'hp_potion_m');
          if(usedPotion >= 0) {
            S.inventory.splice(usedPotion, 1);
            return `药剂落入圣杯的瞬间，祭坛燃起炽热龙焰！
        
火焰不是攻击你——它涌入你的体内。
龙语在耳畔低语：「勇气可嘉。来神殿见我。」`;
          }
          return `你的鲜血滴入圣杯——龙焰瞬间腾起！
        
火焰灼烧着你的伤口，但疼痛很快被一股暖流取代。
龙语在耳畔低语：「用鲜血证明的意志——比药剂更珍贵。」
        
你感到体内多了一股力量。`;
        })(),
        onEnter: function() {
          S.atk = (S.atk||0) + 5;
          S.def = (S.def||0) + 3;
          save();
        },
        choices:[
          { text:'带着龙焰的祝福，前往神殿', next:'sky_2' },
        ]
      },
      { id:'sky_2', title:'天空之城·圣殿之门',
        text:`神殿门前——六道黑翼展开。一个身影悬浮在半空。
        
堕落天使长——光之城主赛格哈特。
它曾是巴卡尔最忠诚的侍卫。
五百年了，它仍守在这里，不允许任何人进入神殿。
        
「巴卡尔大人的遗产……不是给你的。」
它的声音像碎裂的玻璃。
「除非你能证明——你不是赫尔德的棋子。」`,
        choices:[
          { text:'迎战光之城主——证明你的意志', next:'battle_angel_fallen', fatigue:12, needLv:20 },
          { text:'先回赫顿玛尔补充物资', next:'lobby' },
        ]
      },
      { id:'sky_2_done', title:'光之城主·陨落',
        text:`赛格哈特的黑翼燃烧殆尽。它落在地上，单膝跪地。
        
「五百年了……」它的声音不再愤怒，只剩疲惫。
「巴卡尔大人让我等他预言中的那个人。
　一个不被赫尔德操纵的人。」
        
它抬起头，破碎的面甲下露出一只眼睛。
「也许……就是你。」
        
神殿大门缓缓开启。龙鸣声从深处传来——
那不是愤怒，而是等待。五百年的等待。`,
        choices:[
          { text:'穿越神殿暗廊——追寻龙鸣的源头', next:'dark_corridor_0', fatigue:12 },
          { text:'先回大厅做最后准备', action:'home' },
        ]
      },
      // === 黑暗玄廊 ===
      { id:'dark_corridor_0', title:'黑暗玄廊·封印回廊',
        text:`神殿大门之后，不是龙巢，而是一条漫长而幽暗的回廊。

墙壁上的封印铭文来自不同的时代——有一些是巴卡尔的龙语，
但更多是另一种你不认识的文字。它们被后来者覆盖在上面，
像是在试图抹掉什么。

你仔细辨认那些覆盖的符文……是魔法语言。
赫尔德的手法。她来过这里——在巴卡尔死后。

回廊深处，铠甲碰撞的金属声由远及近。
暗之骑士——不是巴卡尔的守卫，
而是赫尔德的爪牙，五百年来一直看守着这道封印。`,
        choices:[
          { text:'迎战暗之骑士——撕开赫尔德的封印', next:'battle_dark_knight_sky', fatigue:12, needLv:21 },
          { text:'退回神殿门前研究那些符文', next:'sky_2_done' },
        ]
      },
      { id:'dark_corridor_1', title:'黑暗玄廊·赫尔德之眼',
        text:`暗之骑士化作黑烟消散。你继续深入回廊。

回廊的墙壁上，一幅巨大的魔法壁画覆盖了整面墙——
赫尔德的面容，用紫晶和黑曜石镶嵌而成。
她的眼睛似乎能跟随你的移动。

壁画下方是一个小型魔法阵——仍在运作。
周围散落着赫尔德的爪牙们留下的记录水晶。

你触碰了一颗水晶，一个冰冷的女声响了起来：

「巴卡尔的龙晶记忆是一个威胁。
　不能让它落入冒险家手中。
　封印它。不惜一切代价。」

回廊更深处，玄廊术士们正在布置更多的魔法陷阱。
他们在为赫尔德铺设新的封印——就在龙巢入口。`,
        choices:[
          { text:'突破术士的封锁——不能让他们继续封印', next:'battle_corridor_mage', fatigue:12 },
          { text:'潜入寻找侧路（几率获得稀有道具）', next:'dark_corridor_secret', fatigue:8 },
        ]
      },
      { id:'dark_corridor_secret', title:'隐藏贮藏室',
        text:`你绕过了术士的防线，在回廊的一个暗格中发现了
赫尔德的爪牙们藏匿的战利品——
显然是从之前击败的冒险家们身上搜刮来的。

其中包括一些相当罕见的物品。`,
        choices:[
          { text:'收下战利品，从后方包抄术士', next:'battle_corridor_mage', fatigue:8, gold:500, item:'hp_potion_l', item2:'mp_potion_m' },
        ]
      },
      { id:'dark_corridor_done', title:'黑暗玄廊·破封',
        text:`最后一个术士倒下——它的法杖碎裂成冰尘。
回廊中的魔法封印开始一层层剥离。

墙壁上赫尔德的画像出现了裂纹——从眼睛开始，
裂痕蔓延到她嘴角的微笑。

龙鸣声突然清晰了。不再是通过层层封印发闷的回声，
而是直接在你前方的黑暗中震响——

龙巢到了。巴卡尔的遗产就在眼前。

神殿最深处的巨门缓缓开启——
那不是普通的门，是由龙晶构成的结界。
五百年来，没有冒险家走到过这里。`,
        choices:[
          { text:'踏入龙巢——直面天空龙王', next:'battle_sky_dragon', fatigue:20, needLv:22 },
          { text:'先回神殿做最后的准备', next:'sky_2_done', healing:20 },
        ]
      },
      { id:'sky_dragon_done', title:'巴卡尔的遗产·真相',
        text:`龙鸣声并非来自活着的龙。
        
神殿中央，一颗巨大的龙晶悬浮在半空。
巴卡尔的声音从中传出——那是他死前留下的记忆。
        
「终于有人来了。不是赫尔德派来的刀，而是真正的
　倾听者。你击败了赛格哈特，证明了自己的意志。」
        
龙晶投射出画面——
        
「赫尔德想要重建魔界故乡泰拉。她的方法很简单
　——杀光所有使徒。但她不能亲自动手，
　所以她利用预言，把使徒转移到阿拉德，
　让你们这些冒险家替她下刀。」
        
「狄瑞吉、希洛克、罗特斯、安图恩……
　包括我，巴卡尔。每一个死去的使徒
　都是赫尔德的棋子。而你们是她的刀。」
        
龙晶闪烁——画面转向一个银发少女。
「第十三位使徒，赛丽亚。她是创世神卡洛索的
　碎片。赫尔德需要她——但必须先让她失去记忆，
　让她依赖人类，让她自愿走向预言中的位置。」
        
「现在你知道了。选择吧——」
        
「继续当赫尔德手中的刀？还是——
　保护赛丽亚，打破这个预言？」`,
        onEnter: function() {
          S.flags.beat_sky = true;
          if(!S.flags._sky_epilogue_shown) {
            S.flags._sky_epilogue_shown = true;
            setTimeout(() => renderChapterEpilogue('sky_city', () => {
              renderLobby(); renderTopbar(); renderStatusbar();
            }), 300);
          }
        },
        choices:[
          { text:'「我选择保护赛丽亚。打破预言。」', next:'final_boss_intro', gold:800 },
          { text:'「我需要更多时间思考……」', next:'lobby', gold:800 },
        ]
      },
      { id:'final_boss_intro', title:'觉醒',
        text:`龙晶碎裂，巴卡尔的遗产涌入你的体内。
那不是武器，不是力量——是真相。
        
你回到地面。赛丽亚在等你。
她的眼神不同了——不再是迷惘的少女，而是
一个正在觉醒的使徒。

「巴卡尔告诉你了？」她轻声问。
「我是第十三使徒。我的存在本身——
　就是赫尔德计划中最关键的一环。」

她松开了一直紧握的手。
掌心有一片小小的龙晶碎片——巴卡尔留给她的。

「这块碎片告诉了我一切。我从哪里来，
　我为什么失去记忆，以及……」
她的声音颤抖了一下。
「以及赫尔德为什么要我活着。」

「我是创世神卡洛索的碎片。只要我存在于阿拉德，
　大魔法阵就能维持。赫尔德需要这个——
　她不能让阿拉德崩溃，因为那是她转移使徒的舞台。」

「所以她才让我活在旅馆里，让我失去记忆，
　让我依赖人类，让我永远不知道自己是谁。」

泪水划过她的脸颊——
但它发出的光不是红色，而是温暖的淡金色。

「但我不想成为棋子。我遇到了你。
　你从来没有问过我'你是谁'——
　你只是把我当成一个普通的旅馆女孩。」

她握住你的手。
「带我离开赫尔德的控制。和我一起——
　她想利用我们两个？我们就偏不。」

远方传来艾丽丝的琵琶声。
琴声变了——不再是预言之歌，而是……战歌。

「你们做出了选择。」艾丽丝的声音在风中传来。
「那么最后的战斗不是对抗使徒。
　而是——向赫尔德宣战。」
        
她的琴弦震动。虚空中，一扇门打开了——
那是赫尔德留在天空之城的一道封印。
门后是阿拉德魔王——赫尔德用来
清理不听话棋子的最后手段。`,
        choices:[
          { text:'迎战赫尔德的使者——反抗命运的第一步', next:'battle_arad_demon', fatigue:20, needLv:25 },
          { text:'先充分准备——这场战斗必须赢', next:'lobby' },
        ]
      },
      { id:'final_victory', title:'∞ 并非终点 ∞',
        text:`赫尔德的使者在你面前化为虚无。
不是因为它弱——而是因为赫尔德不再需要它了。

你们赢了这一战。但赫尔德还在。她的预言还在运转。
更多的使徒正在被转移到阿拉德。

艾丽丝策马而来。她下马，向赛丽亚微微颔首——
这是使徒之间从未有过的敬意。
「这一战只是开始。赫尔德不会放弃的。
　但你们不再是被蒙在鼓里的棋子了。」
她看着你和赛丽亚：「你们现在是她的变数——
　而她最怕的就是变数。」

赛丽亚微笑。那是少女的笑容，
但眼中有着古老星辰的光芒。
「我用了十年才记起自己是谁。
　但现在我知道了：我不是使徒，不是棋子——
　我是赛丽亚，仅此而已。」

她转向你。
「谢谢你。不是为了今天的战斗——
　而是为了在你还不知道我是谁的时候，
　就已经愿意保护我。」

天空之城的云层缓缓散开，阳光照亮了整个阿拉德。
在遥远的天帷巨兽的方向，你能看到蓝鲸庞大的身影。
在北方，雪山的峰顶反射着冰冷的光芒。

赫尔德看到你们了吗？一定看到了。
但这一次，她的棋盘上多了两颗她无法控制的子——

一颗是觉醒的第十三使徒。
一颗是选择不被操纵的冒险家。

★ ★ ★ 阿拉德战记 · 天空之城篇 · 完 ★ ★ ★

✦ 获得：1500 金币

【冒险笔记】
龙晶揭示的真相 + 赛丽亚的真实身份 + 对赫尔德的宣战
——这些都将改写阿拉德的命运。

【后续篇章】
🔵 天帷巨兽：使徒罗特斯的精神污染仍在蔓延
❄️ 万年雪山：冰龙斯卡萨即将完全苏醒
🔮 魔界：赫尔德从未停止她的计划`,
        choices:[
          { text:'🔮 返回大厅——阿拉德的传奇才刚刚开始', next:'lobby', gold:1500 },
        ]
      },
    ]
  },
  // ========== 暗黑城 ==========
  dark_city: {
    name:'暗黑城', lv:15, scenes:[
      { id:'dc_entrance', title:'🕯️ 暗黑城·地下入口',
        text:`赫顿玛尔地下的一处隐秘入口。台阶向下延伸，
黑暗中传来古老的暗精灵低语。墙壁上刻着精灵符文，
微微发着紫光——和格兰之森的那些碎片一样的颜色。

赫顿玛尔最近谣言四起：暗精灵王国正在秘密集结军队，
准备向人类宣战。起因是——诺伊佩拉，暗精灵的圣域，
最近突然爆发了一场诡异的瘟疫。暗精灵认为这是人类的阴谋。

但与格兰之森的碎片打过交道的你，
在空气中闻到了熟悉的甜腻腐败味。

【深入暗黑城】
▶ 暗精灵前哨（Lv.15+）
▶ 亡魂洞穴（Lv.17+，需先通关前哨）
▶ 暗黑要塞（Lv.20+，最终调查）`,
        choices:[
          { text:'探索暗精灵前哨——调查瘟疫的真相', next:'dc_1', needLv:15, fatigue:8 },
          { text:'返回赫顿玛尔', next:'heton_town' },
        ]
      },
      { id:'dc_1', title:'暗精灵前哨·瘟疫前线',
        text:`哨站的暗精灵守卫看你的眼神充满敌意——
但仔细观察，他们的眼中闪烁着病态的紫色微光。
和在格兰之森看到的哥布林一模一样。

这不是战争动员。这是瘟疫感染。
暗精灵不是要攻打人类——他们自己在与疾病斗争。

远处传来金属碰撞的回声。守卫们拖着病体仍在巡逻。`,
        choices:[
          { text:'避开守卫，潜入哨站内部', next:'battle_dark_elf_soldier', fatigue:8 },
          { text:'深入哨站腹地——黑暗中有东西在窥视', next:'battle_shadow_beast', fatigue:6 },
          { text:'返回入口', next:'dc_entrance' },
        ]
      },
      { id:'dc_outpost_done', title:'暗精灵前哨·理解',
        text:`守卫被击退，但他们倒下时眼中的紫光消散了——
那不是敌意，是瘟疫的控制。你在储藏室发现了一些
暗精灵的药草和笔记。笔记上写着：

「圣域诺伊佩拉的瘟疫已经蔓延到了前哨。
　不是人类的毒——是从地下涌出的紫色雾气。
　长老说这和十年前格兰之森的是同一种东西。」

同一种东西。狄瑞吉的瘟疫碎片，
不止落在了格兰之森——也落在了暗精灵的地盘。
        
✦ 获得：200 金币、中级HP药剂 ×2`,
        choices:[
          { text:'继续深入亡魂洞穴——瘟疫的源头在更深处', next:'dc_cavern_1', gold:200, item:'hp_potion_m', item2:'hp_potion_m' },
          { text:'返回入口整备', next:'dc_entrance', gold:200, item:'hp_potion_m', item2:'hp_potion_m' },
        ]
      },
      { id:'dc_cavern_1', title:'亡魂洞穴·千年陵墓',
        text:`地下陵墓豁然开朗。这不是人类的墓地——
是暗精灵祖先的安息之所。无数石棺沿墙壁排列。

但棺盖被撬开了。亡者们没有安息——
紫色的雾气从墓穴中渗出，驱使着死者游荡。

祭坛上，一个暗黑祭司正在吟诵咒文——
但他不是在操控亡者，而是在拼命安抚他们。
他看到你时眼中闪过一丝希望：「人类……
　你身上有对抗这瘟疫的经验……请帮帮我们。」`,
        choices:[
          { text:'帮助暗黑祭司净化祭坛亡者', next:'battle_dark_priest', fatigue:10, needLv:16 },
          { text:'深入陵墓——雾气的源头在更深处翻涌', next:'battle_ghost_knight', fatigue:8 },
          { text:'返回前哨', next:'dc_entrance' },
        ]
      },
      { id:'dc_cavern_done', title:'亡魂洞穴·安息',
        text:`亡者终于安息了。暗黑祭司跪在祭坛前，
他的声音颤抖：「瘟疫的真正源头在暗黑要塞。
　暗影领主大人……他被紫色雾气感染了。
　他现在认为人类是敌人，要发动战争。」

「但这是错的。这不是人类的阴谋，也不是暗精灵的。
　是某种更古老、更黑暗的东西。」
        
✦ 获得：350 金币、高级HP药剂 ×1`,
        choices:[
          { text:'推开石门——进入暗黑要塞，终结瘟疫', next:'dc_citadel_1', gold:350, item:'hp_potion_l' },
          { text:'返回入口整备', next:'dc_entrance', gold:350, item:'hp_potion_l' },
        ]
      },
      { id:'dc_citadel_1', title:'暗黑要塞·被感染的王座',
        text:`石门轰然闭合。暗黑要塞——暗精灵王国的军事心脏。
        
蛛网从穹顶垂落，空气中弥漫着瘟疫的甜腻味——
比格兰之森深处更浓，比诺伊佩拉边缘更烈。

暗精灵士兵倒在地上，不是战死——是病倒。他们的皮肤上
爬着紫色的菌斑，和格兰之森树皮上的一模一样。

深处传来铠甲碰撞声。暗影领主在王座厅里——
他的心智被瘟疫扭曲了。`,
        choices:[
          { text:'穿过被感染的蛛网大厅', next:'battle_spider_queen', fatigue:12, needLv:18 },
          { text:'径直走向王座厅——必须阻止战争', next:'dc_citadel_boss', fatigue:10 },
          { text:'返回亡魂洞穴', next:'dc_cavern_1' },
        ]
      },
      { id:'dc_citadel_boss', title:'暗黑要塞·王座厅',
        text:`黑曜石王座在黑暗中散发出不祥的紫光。
暗影领主端坐其上——他的盔甲缝隙中渗出浓郁的紫色雾气，
和骨狱息体内的一模一样。

他的眼睛不再属于暗精灵的睿智统治者，
而是被狄瑞吉瘟疫侵蚀的疯狂。

「人类……带来了瘟疫……必须……消灭……」
他站起身，黑曜石巨剑从地面升起。
那不是他的意志在说话——是瘟疫在替他说话。`,
        choices:[
          { text:'⚔️ 击败被感染的王——解救暗精灵', next:'battle_shadow_lord', fatigue:15, needLv:20 },
        ]
      },
      { id:'dc_citadel_done', title:'暗黑要塞·紫色消散',
        text:`暗影领主的盔甲碎裂——但从碎片中涌出的不是血，
而是大量紫色的雾气和结晶碎片。和格兰之森的一样——
搏动的、活着的碎片。

雾气散尽后，暗影领主倒在地上。他睁开眼睛——
瞳孔恢复了暗精灵原本的琥珀色。

「人类……是你救了我。」他虚弱地说。
「这瘟疫比我们想象的更危险。它不止感染了
　格兰之森和诺伊佩拉……它在向地面蔓延。」

「告诉赫顿玛尔——暗精灵不会发动战争。
　我们和人类一样，是这场瘟疫的受害者。」
「如果有谁在背后操控这一切——
　我们需要并肩作战，而不是互相残杀。」

你答应了。暗黑城迎来了短暂的光明——
但你知道，狄瑞吉的碎片不止这两处。
        
🏆 暗黑城 调查完成！
✦ 获得：600 金币、高级HP药剂 ×2
        
【暗线解锁】瘟疫来源确认：狄瑞吉碎片的转移是系统性的——赫尔德同时在多点散布瘟疫`,
        onEnter: function() {
          S.flags.beat_dark_city = true;
          if(!S.flags._dark_epilogue_shown) {
            S.flags._dark_epilogue_shown = true;
            setTimeout(() => renderChapterEpilogue('dark_city', () => {
              if(S.scene === 'lobby') { renderLobby(); renderTopbar(); renderStatusbar(); }
            }), 300);
          }
        },
        choices:[
          { text:'返回赫顿玛尔——告知暗精灵和平的消息', next:'heton_town', gold:600, item:'hp_potion_l', item2:'hp_potion_l' },
          { text:'返回大厅', next:'lobby', gold:600, item:'hp_potion_l', item2:'hp_potion_l' },
        ]
      },
    ]
  },
};
